import React from 'react';
import { NavLink } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import Link from 'ati-ui-react/components/Link';

import getEnvironDomain from 'utils/getEnvironDomain';
import noMatchTruck from './img/noMatch.svg';
import { NoMatchContainer, Heading, Description, LinksContainer } from './NoMatchStyles';

const NoMatch = observer(() => {
  return (
    <NoMatchContainer>
      <img src={noMatchTruck} alt="" />
      <Heading>Объявления нет</Heading>
      <Description>Возможно, оно в архиве, удалено или более недоступно.</Description>
      <LinksContainer>
        <Link
          className="custom-link"
          href={`https://${getEnvironDomain()}`}
          rel="noopener noreferrer"
        >
          На главную страницу
        </Link>
        <NavLink className="custom-navlink" to="/trucks">
          <Link className="custom-link">В поиск объявлений</Link>
        </NavLink>
      </LinksContainer>
    </NoMatchContainer>
  );
});

export default NoMatch;
